document.addEventListener('DOMContentLoaded', () => {
    if (!location.pathname.includes('/products/')) return;
    if (history.length <= 1) return;

    const btn = document.createElement('button');
    btn.id = 'c-back-btn';
    btn.setAttribute('aria-label', 'Back');
    btn.textContent = '‹';
    btn.addEventListener('click', () => history.back());
    document.body.appendChild(btn);
    requestAnimationFrame(() => btn.classList.add('is-visible'));
});